import { Toast, NotificationData } from '@models/*';
import { CoreActions, CoreActionTypes, UiActions, UiActionTypes } from '../actions';
import { TourActions, TourActionTypes } from '../../overview/store/actions';

export interface UiState {
    toasts: Toast[];
    galleryData: { photos: string[], startIndex: number };
    notifications: NotificationData[];
    openedNotificationId: number;
    refreshMandatory: boolean;
    animatingUpdatedTourIds: number[];
}

const initState: UiState = {
    toasts: [],
    galleryData: null,
    notifications: [],
    openedNotificationId: null,
    refreshMandatory: false,
    animatingUpdatedTourIds: []
};

export function uiReducer(state = initState, action: UiActions | CoreActions | TourActions): UiState {

    switch (action.type) {
        case UiActionTypes.ADD_TOAST: {
            const newId = (state.toasts.length) ? state.toasts[state.toasts.length - 1].id + 1 : 1;
            const newToast = { ...action.payload, id: newId };
            const newToasts = [...state.toasts, newToast];

            return {
                ...state,
                toasts: newToasts
            };
        }

        case UiActionTypes.DISMISS_TOAST: {
            const newToasts = state.toasts.filter((item: Toast) => item.id !== action.payload);

            return {
                ...state,
                toasts: newToasts
            };
        }

        case UiActionTypes.ADD_GALLERY_DATA: {
            return {
                ...state,
                galleryData: action.payload
            };
        }

        case UiActionTypes.EMPTY_GALLERY_DATA: {
            return {
                ...state,
                galleryData: null
            };
        }

        case UiActionTypes.ADD_NOTIFICATION: {
            const logoutNotification = state.notifications.find(notif => notif.type === 'app-require-logout');

            const newId = (state.notifications.length) ? state.notifications[state.notifications.length - 1].id + 1 : 1;
            const newNotification = { ...action.payload.notification, id: newId };
            const newNotifications = [...state.notifications, newNotification];

            return {
                ...state,
                openedNotificationId: logoutNotification ? logoutNotification.id : newId,
                refreshMandatory: action.payload.duringOffline,
                notifications: newNotifications
            };
        }

        case UiActionTypes.CLEAR_NOTIFICATION: {
            const newNotifications = state.notifications.filter((item: NotificationData) => item.id !== action.payload);

            return {
                ...state,
                notifications: newNotifications
            };
        }

        case UiActionTypes.CLEAR_ALL_NOTIFICATIONS: {
            return {
                ...state,
                notifications: []
            };
        }

        case UiActionTypes.OPEN_NOTIFICATION: {
            return {
                ...state,
                openedNotificationId: action.payload
            };
        }

        case UiActionTypes.HIDE_NOTIFICATIONS: {
            return {
                ...state,
                openedNotificationId: null
            };
        }

        case CoreActionTypes.BACK_ONLINE: {
            let openedNotificationId;

            if (state.refreshMandatory) {
                openedNotificationId = state.notifications[state.notifications.length - 1].id;
            } else {
                openedNotificationId = null;
            }

            return {
                ...state,
                openedNotificationId
            };
        }

        case TourActionTypes.LOAD_TOUR_SINGLE_SUCCESS: {
            const animatingUpdatedTourIds = [...state.animatingUpdatedTourIds, action.payload.id];

            return {
                ...state,
                animatingUpdatedTourIds
            };
        }

        case UiActionTypes.CANCEL_UPDATED_TOUR_ANIMATION: {
            const animatingUpdatedTourIds = state.animatingUpdatedTourIds.filter(id => id !== action.payload);

            return {
                ...state,
                animatingUpdatedTourIds
            };
        }
    }

    return state;
}
